import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { ALL_CONTENT_ROUTES } from '@/app/private/my-content/views/all/all.router';
import { MY_CONTENT_ROUTES } from '@/app/private/my-content/my-content.router';
@Component({})
class EdBreadCrumbs extends Vue {
  
  get breadcrumbs(): any[] {
    let breadcrumbs = [{
      label: this.$i18n.t('breadcrumbs.home'),
      path: `${KEYS.CONTEXT}/portal/tasks`,
      routing: false,
      name: 'private.portal'
    }];
    let pathRoute = this.$route.path;
    let pathToSplit = this.$route.path.replace(`${KEYS.CONTEXT}/`, '');
    let pathItems = pathToSplit.split('/'); 
    pathItems.map(m => {
      let label = this.$i18n.t(`breadcrumbs.${m}`);
      if(label != `breadcrumbs.${m}`) {
        breadcrumbs.push({
          label: label,
          path: `${pathRoute.split(m)[0]}${m}`,
          routing: true,
          name: m
        });
      }
    });
    return breadcrumbs;
  }

  goToPath(name: string) {
    if(this.breadcrumbs[this.breadcrumbs.length - 1].name !== name) {
      const route = this.getRoute(name);
      this.$router.push({ name: route }).catch(() => {});
    }
  }

  getRoute(name) {
    let fullName = name;
    switch(name) {
      case 'myContent':
        fullName = ALL_CONTENT_ROUTES.SUBJECTS.NAME;
        if(this.$store.getters['AuthStore/isStudent']) {
          fullName = ALL_CONTENT_ROUTES.PURCHASED.NAME;
        }
      break;
      case 'all':
        fullName = MY_CONTENT_ROUTES.ALL.NAME;
        if(this.$store.getters['AuthStore/isStudent']) {
          fullName = ALL_CONTENT_ROUTES.PURCHASED.NAME;
        }
      break;
    }
    return fullName;
  }

}

export default Vue.component('ed-breadcrumbs', EdBreadCrumbs);